import { FC } from 'react'
import { Box, Typography } from '@mui/material'

import { BasicCell } from '../ssm.styles'
import { IdentifierBox } from './nistPillar.styles'

interface Props {
  nistPillarText: string
  productCount?: number
  nistValueText?: string
  background: string
}

const NistPillar: FC<Props> = ({ nistPillarText, productCount, nistValueText, background }) => (
  <BasicCell>
    <Box className="nist-top">
      <IdentifierBox background={background} />
      <Typography className="nist-pillar-text">{nistPillarText}</Typography>
    </Box>
    {productCount !== undefined ? (
      <Box className="nist-value-text">
        <span className="nist-value-count">{productCount}</span>
        <span className="nist-value-label">{productCount === 1 ? 'product' : 'products'}</span>
      </Box>
    ) : (
      <Box className="nist-value-text">
        <span className="nist-value-count">{nistValueText}</span>
      </Box>
    )}
  </BasicCell>
)

export default NistPillar
